export default __webpack_public_path__ + "static/error2-a98f463eec9a68f8111d4e4d428611fa.png";